import React from "react"
import * as styles from "../../styles/page/second.module.scss"
import { useStaticQuery, graphql } from "gatsby"
import ShareButtons from "../../components/parts/share-button"

/* 特定のプロジェクト情報を取得 */
export const getCurrentProject = (slug, type = '') => {
  const { allProjects } = GetProject()
  const project = allProjects.filter(item => {
    return `/project/${item.node.slug}${type}` === slug
  })
  return project
}

export const getEnvironmentalPrefix = (param) => {
  const { slug, current, alt } = param
  const replaceCheck = (current === 'overview') ? false : current
  const prefix = process.env.GATSBY_ACTIVE_ENV === 'development' ? '/images' : '/en/images'
  const path = (replaceCheck) ? `${prefix}${slug.replace(current+'/', '')}` : `${prefix}${slug}`
  return { 
    alt,
    path,
  }
}

/* メインイメージ */
export const MainImage = (props) => {
  const { alt, path } = getEnvironmentalPrefix(props);
  return (
    <img className={styles.mainImage} src={`${path}main.png`} alt={alt} />
  )
}
/* サブイメージ */
export const SubImage = (props) => {
  const { alt, path } = getEnvironmentalPrefix(props);
  return (
    <img className={styles.subImage} src={`${path}sub.png`} alt={alt} />
  )
}

/* タブ */
export const ProjectTab = (props) => {
  const { current, slug } = props
  const path = (current === 'overview') ? './' : '../'
  const project = getCurrentProject(slug, (current === 'overview') ? '/' : `/${current}/`)
  const { summary, scheme, progress } = project[0].node

  return (
    <div className={styles.articleTabWrapper}>
      <ul className={styles.articleTab}>
        <li className={current === 'overview' ? styles.active : ''}><a href={path} data-label="overview">Overview</a></li>
        {
          (summary) ? 
            <li className={current === 'summary' ? styles.active : ''}><a href={`${path}summary/`} data-label="summary">Summary</a></li> : ''
        }
        {
          (scheme) ?
            <li className={current === 'scheme' ? styles.active : ''}><a href={`${path}scheme/`} data-label="scheme"><small>Project Scheme</small></a></li> : ''
        }
        {
          (progress) ?
            <li className={current === 'progress' ? styles.active : ''}><a href={`${path}progress/`} data-label="progress"><small>Progress</small></a></li> : ''
        }
      </ul>
      <ShareButtons style={styles.articleSns} url={`https://${process.env.HOST_NAME}${slug}`} />
    </div>
  )
}

const GetProject = () => {
  const { projects } = useStaticQuery(graphql`
    query getProjectQuery {
      projects: allProjectsJson {
        edges {
          node {
            slug
            title
            description
            mainImage
            progress
            scheme
            summary
          }
        }
      }
    }`
  )
  const allProjects = projects.edges

  return {
    allProjects,
  }
}